import React, { ReactElement, FC } from "react";
import clsx from "clsx";
import Icon from "@material-ui/core/Icon";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { useHistory } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  CssBaseline,
  Typography,
  IconButton,
  Tooltip,
} from "@material-ui/core";

import MenuIcon from "@material-ui/icons/Menu";
import Brightness7Icon from "@material-ui/icons/Brightness7";
import Brightness3Icon from "@material-ui/icons/Brightness3";
import UserIcon from "@material-ui/icons/AccountCircle";
import LogoutIcon from "@material-ui/icons/LockOutlined";
import LogoutIcon1 from "@material-ui/icons/ExitToAppOutlined";
import LogoutIcon2 from "@material-ui/icons/ExitToApp";
import LogoutIN from "@material-ui/icons/LockOpenOutlined";
import LogoutIN2 from "@material-ui/icons/MeetingRoom";

import SvgIcon from "@material-ui/core/SvgIcon";
// constants
import { APP_TITLE, DRAWER_WIDTH } from "../../helpers/constants";
//Use Redux hooks to get to see user is logged in and get actions for disptach
import { useAppSelector, useAppDispatch } from '../../hooks/reduxHooks';
import { selectStellar } from "../stellar/xlmSlice";
//Import AuthSlice
import {selectAuth} from '../auth/authSlice';

// define css-in-js
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      marginLeft: DRAWER_WIDTH,
      width: `calc(100% - ${DRAWER_WIDTH}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    toolbar: {
      flex: 1,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    title: {
      flex: 1,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    menuButton: {
      marginRight: 36,
    },
    hide: {
      display: "none",
    },
    imageIcon: {
      height: "100%",
    },
    iconRoot: {
      textAlign: "center",
    },
  })
);

// define interface to represent component props
interface Props {
  open: boolean;
  handleMenuOpen: () => void;
  handleSignUp: () => void;
  handleSignIn: () => void;
  handleDisconnect: () => void;
  toggleTheme: () => void;
  useDefaultTheme: boolean;
}


const Header: FC<Props> = ({
  open,
  handleMenuOpen,
  handleSignUp,
  handleSignIn,
  handleDisconnect,
  toggleTheme,
  useDefaultTheme,
}): ReactElement => {
  const classes = useStyles();
  const history = useHistory();
  //remove and switch for Firebase 
  const authState = useAppSelector(selectAuth);

  const dispatch = useAppDispatch();
  const isLoggedIn = authState.isLoggedIn;
  const authProvider = authState.provider;

  let error: boolean = false;

  return (
    <>
      <CssBaseline />
      <AppBar
        position="fixed"
        elevation={0}
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar className={classes.toolbar}>
          <div className={classes.title}>
            <IconButton
              color="inherit"
              aria-label="open menu"
              onClick={handleMenuOpen}
              edge="start"
              className={clsx(classes.menuButton, {
                [classes.hide]: open,
              })}
              size="small"
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" noWrap>
              {APP_TITLE}
            </Typography>
          </div>
          <IconButton onClick={toggleTheme}>
            {useDefaultTheme ? (
              <Tooltip title="Switch to dark mode" placement="bottom">
                <Brightness3Icon />
              </Tooltip>
            ) : (
              <Tooltip title="Switch to light mode" placement="bottom">
                <Brightness7Icon />
              </Tooltip>
            )}
          </IconButton>

          {!isLoggedIn && (
            <IconButton size="small" onClick={handleSignIn} color="inherit">
              <Icon classes={{ root: classes.iconRoot }}>
                <LogoutIN />
              </Icon>
            </IconButton>
          )}
          {isLoggedIn && (
            <IconButton size="small" onClick={handleDisconnect} color="inherit">
              <LogoutIcon />
            </IconButton>
          )}
          {isLoggedIn && (
            <IconButton size="small" color="inherit">
              <UserIcon />
            </IconButton>
          )}
        </Toolbar>
      </AppBar>
    </>
  );
};

export default Header;
